import * as L from "leaflet";
import * as Global from "./global";

export function getMapTileLayer(): L.TileLayer {
    // https://docs.mapbox.com/help/troubleshooting/migrate-legacy-static-tiles-api/
    return L.tileLayer("https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}", {
        attribution: "© <a href='https: //www.mapbox.com/about/maps/'>Mapbox</a> © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a> " +
                     "<strong><a href='https://www.mapbox.com/map-feedback/' target='_blank'>Improve this map</a></strong>",
        tileSize: 512,
        maxZoom: 18,
        zoomOffset: -1,
        id: "mapbox/streets-v11",
        accessToken: Global.app().global.MapboxAccessToken,
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/mapUtil.ts